// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import cognito from './cognito'
import apig from './apig'
import store from './store/index'
import AWSAppSyncClient from 'aws-appsync'
import VueApollo from 'vue-apollo'
import VueGtm from 'vue-gtm'
import VueScrollTo from 'vue-scrollto'
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker'
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css'

// bootstrap
import BootstrapVue from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

// fontawesome
import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { fab } from '@fortawesome/free-brands-svg-icons'
import { far } from '@fortawesome/free-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

// clipboard
import VueClipboard from 'vue-clipboard2'

// spinner
import ClipLoader from 'vue-spinner/src/ClipLoader.vue'
import BounceLoader from 'vue-spinner/src/BounceLoader.vue'
import RingLoader from 'vue-spinner/src/RingLoader.vue'
import MoonLoader from 'vue-spinner/src/MoonLoader.vue'

// toggle
import ToggleButton from 'vue-js-toggle-button'

// carousel
import VueCarousel from 'vue-carousel'

// Sentry
import * as Sentry from '@sentry/vue'
import { Integrations } from '@sentry/tracing'

if (process.env.SENTRY_AUTH_TOKEN) {
  Sentry.init({
    Vue,
    dsn: 'https://4711be5c6b2143a4a0a0a69f3beaf266@o525776.ingest.sentry.io/5641186',
    integrations: [new Integrations.BrowserTracing()],

    // We recommend adjusting this value in production, or using tracesSampler
    // for finer control
    tracesSampleRate: 1.0
  })
}

const config = {
  url: process.env.APP_SYNC_CONFIG.graphqlEndpoint,
  region: process.env.APP_SYNC_CONFIG.region,
  auth: {
    type: process.env.APP_SYNC_CONFIG.authType,
    apiKey: process.env.APP_SYNC_CONFIG.apiKey
  }
}

const options = {
  defaultOptions: {
    watchQuery: {
      fetchPolicy: 'cache-and-network'
    }
  }
}

const client = new AWSAppSyncClient(config, options)

const appsyncProvider = new VueApollo({
  defaultClient: client
})

Vue.use(VueApollo)
Vue.use(VueScrollTo)

library.add(fas, far, fab)
Vue.use(VueGtm, {
  id: 'GTM-5VV6JKP',
  enabled: true,
  debug: false,
  vueRouter: router
})
Vue.use(BootstrapVue)
Vue.use(ToggleButton)
Vue.use(VueClipboard)
Vue.use(VueCarousel)
Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.component('clip-loader', ClipLoader)
Vue.component('bounce-loader', BounceLoader)
Vue.component('ring-loader', RingLoader)
Vue.component('moon-loader', MoonLoader)
Vue.component('VueCtkDateTimePicker', VueCtkDateTimePicker)

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  cognito,
  apig,
  store,
  components: { App },
  apolloProvider: appsyncProvider,
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js